// src/actions/adminActions.js
import createApiAction from "./apiActions";
import * as actionTypes from "./actionTypes";
import { LOGOUT } from "./actionTypes";

export const login = (credentials) =>
  createApiAction({
    method: "post",
    endpoint: "/login",
    data: credentials,
    requestType: actionTypes.LOGIN_REQUEST,
    successType: actionTypes.LOGIN_SUCCESS,
    failureType: actionTypes.LOGIN_FAILURE,
    showToast: true,

    onFailure: (dispatch) => {
      dispatch(logout());
    },
  });

export const logout = () => (dispatch) => {
  dispatch({ type: LOGOUT });
  localStorage.clear();
};

export const fetchPaymentOptions = () =>
  createApiAction({
    method: "get",
    endpoint: "/save_payment_option",
    requestType: actionTypes.FETCH_PAYMENT_OPTIONS_REQUEST,
    successType: actionTypes.FETCH_PAYMENT_OPTIONS_SUCCESS,
    failureType: actionTypes.FETCH_PAYMENT_OPTIONS_FAILURE,
    showToast: false,
  });

export const fetchAllUsers = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/get-all-users?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_ALL_USERS_REQUESTS_REQUEST,
    successType: actionTypes.FETCH_ALL_USERS_REQUESTS_SUCCESS,
    failureType: actionTypes.FETCH_ALL_USERS_REQUESTS_FAILURE,
    showToast: false,
  });

export const fetchCappingUser = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/get_capping_users?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_CAPPING_DATA_REQUEST,
    successType: actionTypes.FETCH_CAPPING_DATA_SUCCESS,
    failureType: actionTypes.FETCH_DASHBOARD_DATA_FAILURE,
    showToast: false,
  });

export const fetchAllOrder = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/get_all_orders?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_ALL_ORDER_REQUEST,
    successType: actionTypes.FETCH_ALL_ORDER_SUCCESS,
    failureType: actionTypes.FETCH_ALL_ORDER_FAILURE,
    showToast: false,
  });
export const fetchAllSIP = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/get_all_Sips?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_ALL_SIP_REQUEST,
    successType: actionTypes.FETCH_ALL_SIP_SUCCESS,
    failureType: actionTypes.FETCH_ALL_SIP_FAILURE,
    showToast: false,
  });
export const fetchSIPInstallment = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/upcominginstallments?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_SIP_INSTALLMENT_REQUEST,
    successType: actionTypes.FETCH_SIP_INSTALLMENT_SUCCESS,
    failureType: actionTypes.FETCH_SIP_INSTALLMENT_FAILURE,
    showToast: false,
  });
export const fetchUnpaidInstallment = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/unpaidinstallments?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_UNPAID_INSTALLMENT_REQUEST,
    successType: actionTypes.FETCH_UNPAID_INSTALLMENT_SUCCESS,
    failureType: actionTypes.FETCH_UNPAID_INSTALLMENT_FAILURE,
    showToast: false,
  });
export const fetchAllRewards = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/all_reward_request?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_ALL_REWARD_REQUEST,
    successType: actionTypes.FETCH_ALL_REWARD_SUCCESS,
    failureType: actionTypes.FETCH_ALL_REWARD_FAILURE,
    showToast: false,
  });
export const fetchAllRanks = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/get-ranks?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_ALL_RANKS_REQUEST,
    successType: actionTypes.FETCH_ALL_RANKS_SUCCESS,
    failureType: actionTypes.FETCH_ALL_RANKS_FAILURE,
    showToast: false,
  });
export const fetchUplineBonus = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/get_upline_bonus?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_UPLINE_BONUS_REQUEST,
    successType: actionTypes.FETCH_UPLINE_BONUS_SUCCESS,
    failureType: actionTypes.FETCH_UPLINE_BONUS_FAILURE,
    showToast: false,
  });
export const fetchAllPower = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/get-all-power?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_ALL_POWER_REQUEST,
    successType: actionTypes.FETCH_ALL_POWER_SUCCESS,
    failureType: actionTypes.FETCH_ALL_POWER_FAILURE,
    showToast: false,
  });
export const approveRewardRequest = (requestIds, item, rewardItem) =>
  createApiAction({
    method: "post",
    endpoint: "/approve_reward_request",
    data: { requestIds, item, rewardItem },
    requestType: actionTypes.APPROVE_REWARD_REQUEST_REQUEST,
    successType: actionTypes.APPROVE_REWARD_REQUEST_SUCCESS,
    failureType: actionTypes.APPROVE_REWARD_REQUEST_FAILURE,
    showToast: true,
  });
export const rejectRewardRequest = (requestIds, item, rewardItem, message) =>
  createApiAction({
    method: "post",
    endpoint: "/reject_reward_request",
    data: { requestIds, item, rewardItem, message },
    requestType: actionTypes.REJECT_REWARD_REQUEST_REQUEST,
    successType: actionTypes.REJECT_REWARD_REQUEST_SUCCESS,
    failureType: actionTypes.REJECT_REWARD_REQUEST_FAILURE,
    showToast: true,
  });
export const fetchAllTransaction = (queryParams) =>
  createApiAction({
    method: "get",
    endpoint: `/get-payment-transaction?${new URLSearchParams(queryParams).toString()}`,
    requestType: actionTypes.FETCH_ALL_PAYMENT_REQUESTS_REQUEST,
    successType: actionTypes.FETCH_ALL_PAYMENT_REQUESTS_SUCCESS,
    failureType: actionTypes.FETCH_ALL_PAYMENT_REQUESTS_FAILURE,
    showToast: false,
  });

export const approvePaymentRequest = (requestIds) =>
  createApiAction({
    method: "post",
    endpoint: "/approve-payment-request",
    data: { requestIds },
    requestType: actionTypes.APPROVE_PAYMENT_REQUEST_REQUEST,
    successType: actionTypes.APPROVE_PAYMENT_REQUEST_SUCCESS,
    failureType: actionTypes.APPROVE_PAYMENT_REQUEST_FAILURE,
    showToast: true,
  });

export const approveWithdrawalRequest = (requestIds, tx_hash) =>
  createApiAction({
    method: "post",
    endpoint: "/approve-withdrawal-request",
    data: { requestIds, tx_hash },
    requestType: actionTypes.APPROVE_PAYMENT_REQUEST_REQUEST,
    successType: actionTypes.APPROVE_PAYMENT_REQUEST_SUCCESS,
    failureType: actionTypes.APPROVE_PAYMENT_REQUEST_FAILURE,
    showToast: true,
  });

export const rejectPaymentRequest = (requestIds, message) =>
  createApiAction({
    method: "post",
    endpoint: "/reject-payment-request",
    data: { requestIds, message },
    requestType: actionTypes.REJECT_PAYMENT_REQUEST_REQUEST,
    successType: actionTypes.REJECT_PAYMENT_REQUEST_SUCCESS,
    failureType: actionTypes.REJECT_PAYMENT_REQUEST_FAILURE,
    showToast: true,
  });
export const rejectWithdrawalRequest = (requestIds, message) =>
  createApiAction({
    method: "post",
    endpoint: "/reject-withdrawal-request",
    data: { requestIds, message },
    requestType: actionTypes.REJECT_PAYMENT_REQUEST_REQUEST,
    successType: actionTypes.REJECT_PAYMENT_REQUEST_SUCCESS,
    failureType: actionTypes.REJECT_PAYMENT_REQUEST_FAILURE,
    showToast: true,
  });

export const fetchDashboardData = () =>
  createApiAction({
    method: "get",
    endpoint: "/get-dashboard-data",
    requestType: actionTypes.FETCH_DASHBOARD_DATA_REQUEST,
    successType: actionTypes.FETCH_DASHBOARD_DATA_SUCCESS,
    failureType: actionTypes.FETCH_DASHBOARD_DATA_FAILURE,
    showToast: false,
  });

export const fetchPaymentTransactions = () =>
  createApiAction({
    method: "get",
    endpoint: "/get-payment-transaction",
    requestType: actionTypes.FETCH_PAYMENT_TRANSACTIONS_REQUEST,
    successType: actionTypes.FETCH_PAYMENT_TRANSACTIONS_SUCCESS,
    failureType: actionTypes.FETCH_PAYMENT_TRANSACTIONS_FAILURE,
    showToast: false,
  });

export const releasedIncome = (requestIds, income, target_wallet) =>
  createApiAction({
    method: "post",
    endpoint: "/release_income",
    data: { requestIds, income, target_wallet },
    requestType: actionTypes.RELEASED_INCOME_REQUEST,
    successType: actionTypes.RELEASED_INCOME_SUCCESS,
    failureType: actionTypes.RELEASED_INCOME_FAILURE,
    showToast: true,
  });

export const fetchApiRoutes = () =>
  createApiAction({
    method: "get",
    endpoint: "/get-routes",
    requestType: actionTypes.FETCH_ROUTES_REQUEST,
    successType: actionTypes.FETCH_ROUTES_SUCCESS,
    failureType: actionTypes.FETCH_ROUTES_FAILURE,
    showToast: false,
  });
